import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import ModalCliente from '../Clientes/Modal';
import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker";
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput";
import ParadigmaDatePicker from "../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ModalLoteo from "../Loteos/Modal";

import moment from 'moment';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fecha: moment(),
            vendedor_id: null,
            cliente_id: [],
            loteo_id: null,
            lote_id: null,
            comentarios: '',
            postVariables: [
                'fecha',
                'vendedor_id',
                'cliente_id',
                'loteo_id',
                'lote_id',
                'comentarios'
            ],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            fecha: moment(),
            vendedor_id: null,
            cliente_id: [],
            loteo_id: null,
            lote_id: null,
            comentarios: '',
            errors: [],
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        return data;
    }

    setData(data) {
        const { action } = this.props;
        if (action === 'EDIT' && data.tieneventa) {
            return {
                allowed: false,
                message: 'No puede editar una consulta asociada a una venta. Intente editar la venta correspondiente.'
            };
        }
        if (data.success) {
            this.setState({
                fecha: moment(data.fecha),
                vendedor_id: data.vendedor.id,
                cliente_id: data.cliente.id,
                loteo_id: data.loteo.id,
                lote_id: data.lote.id,
                comentarios: data.comentarios,
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Consulta",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Consulta ha sido creada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Consulta",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Consulta ha sido editada con éxito.",
                saveButton: true,
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Consulta",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Consulta",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Consulta ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: 'Eliminar',
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    setVendedor = () => {
        const { action } = this.props;
        if (action === 'CREATE') {
            const userId = localStorage.id;
            if (userId) {
                this.setState({
                    vendedor_id: userId,
                });
            }
        }
    }

    render() {
        let vars = this.modalVars();
        const { loteo_id } = this.state;
        const { action } = this.props;

        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.ventas.consultas : null)}
                submitUrl={(vars.submitType ? api.ventas.consultas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onOpen={this.setVendedor}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}

                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                saveButtonLabel={vars.saveButtonLabel}
                closeButton={true}
                className="ui-paradigma-modal ui-paradigma-modal-wide"
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Identificación</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Fecha"}
                            error={() => this.getError('fecha')}
                            inputComponent={
                                <ParadigmaDatePicker
                                    disabled={vars.disabled}
                                    value={this.state.fecha}
                                    onChange={data => this.onChangeField('fecha', data)}
                                />
                            }
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Vendedor"}
                            error={() => this.getError('vendedor_id')}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    displayField="apellido_nombre"
                                    //url={api.usuarios.usuarios}
                                    //url={api.users_select}
                                    url={api.vendedores.usuarios}
                                    parameters={{
                                         paginationEnabled:false,
                                    }}
                                    disabled={vars.disabled}
                                    value={this.state.vendedor_id}
                                    onChange={data => this.onChangeField('vendedor_id', (data) ? data.id : null)}
                                />
                            }
                        />
                    </div>
                </section>
                <section className="ui-modal-section">
                    <p className="ui-section-label">Datos de la consulta</p>
                    <div className="ui-form-grid">
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Cliente"}
                                error={() => this.getError('cliente_id')}
                                inputComponent={
                                    <div className="ui-async-action-field">
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            //url={api.clientes}
                                            url={api.clientes.select}
                                            parameters={{
                                                 paginationEnabled:false,
                                                 sort:['apellido'],
                                            }}
                                            disabled={vars.disabled}
                                            value={this.state.cliente_id}
                                            displayField="nombre_completo"
                                            onChange={data => this.onChangeField('cliente_id', (data)?data.id:null)}
                                            CreateComponent={action === "CREATE"? props => <ModalCliente {...props} action="CREATE" />:null}
                                        />
                                    </div>
                                }
                            />
                        </div>
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Loteo"}
                            error={() => this.getError('loteo_id')}
                            inputComponent={
                                <div className="ui-async-action-field">
                                    <ParadigmaAsyncSeeker
                                        clearable={false}
                                        //url={api.loteos.loteos}
                                        url={api.loteos.loteos_select}
                                        parameters={{
                                             paginationEnabled:false,
                                             sort:['nombre']
                                        }}
                                        disabled={vars.disabled}
                                        value={this.state.loteo_id}
                                        onChange={data => this.onChangeField('loteo_id', (data)?data.id:null)}
                                        DetailComponent={this.state.loteo_id ? (props => <ModalLoteo {...props} action="DETAIL" activeTab={3} />) : null}
                                    />
                                </div>
                            }
                        />
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Lote"}
                            error={() => this.getError('lote_id')}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    optionRenderer={opts => `${opts.manzana} - ${opts.numero}`}
                                    valueRenderer={opts => `Manzana: ${opts.manzana} - Número: ${opts.numero}`}
                                    url={this.state.loteo_id ? api.loteos.lotes : ''}
                                    parameters={{
                                         id:this.state.loteo_id,
                                         paginationEnabled:false,
                                         sort:['manzana'],
                                         concat: action === 'CREATE' && this.state.loteo_id != undefined? (this.state.vendedor_id ? `vendido=False&vendedor_id=${this.state.vendedor_id}` : 'vendido=False') : '',
                                    }}
                                    disabled={vars.disabled}
                                    value={this.state.lote_id}
                                    onChange={data => this.onChangeField('lote_id', (data)?data.id:null)}
                                />
                            }
                        />
                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Comentarios"}
                                type="textarea"
                                value={this.state.comentarios}
                                onChange={e => this.onChangeField('comentarios', e.target.value)}
                                error={() => this.getError('comentarios')}
                            />
                        </div>

                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label=""
                                error={() => this.getError('consulta')}
                                inputComponent={<span></span>}
                            />
                        </div>
                    </div>
                </section>

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Consultas/Modal.js